import { useState, type Dispatch, type SetStateAction } from 'react'
import toast from 'react-hot-toast'
import { Handle, NodeProps, Position } from "reactflow"
import { translations } from '../../../configs/translations'
import { useStore } from '../../../store/store'
import { getCarImagePath } from '../../../utils/getCarImagePath'
import './CarNode.css'
import { CarNodeButton } from './carNodeButton/CarNodeButton'

export type CarNodeProps = {
	name: string,
	brand: string,
	rank: number,
	button?: {
		type: 'RESEARCH' | 'BUY' | 'DONATE',
		price: number,
		onClick: () => Promise<void>
	}
	checked?: boolean,
	onClick: () => void,
	isDonated?: boolean,
	isInModules?: boolean,
	experience?: number,
	hoverCarNode?: Function,
	setTriggerUpdate: Dispatch<SetStateAction<number>>
}

export const CarNode = (props: NodeProps<CarNodeProps>) => {
	const { 
		name, 
		brand, 
		button, 
		checked, 
		isDonated, 
		isInModules, 
		experience, 
		hoverCarNode, 
		rank, 
		setTriggerUpdate, 
		onClick 
	} = props.data
	const [showButton, setShowButton] = useState(true)
	const language = useStore(state => state.language) as keyof typeof translations
	const t = translations[language]

	const isDarken = () => {
		return !checked && !button && !isDonated && !isInModules
	}

	const handleClick = () => {
		if (!button) return
		const reasearchSound = new Audio('/sounds/research.mp3')
		const buySound = new Audio('/sounds/buy.mp3')

		setShowButton(false)
		button.onClick().then(
			() => {
				setShowButton(true)
				if (button.type === 'RESEARCH') reasearchSound.play()
				if (button.type === 'BUY' || button.type === 'DONATE') buySound.play()
				setTriggerUpdate((prev: number) => prev + 1)
			}
		).catch((error) => {
			setShowButton(true)
			toast.error(
				error &&
					error.response &&
					error.response.data &&
					t[error.response.data as keyof typeof t]
					? t[error.response.data as keyof typeof t]
					: t.error_unknown,
				{ className: 'notification-error' }
			)
		})
	}

	return (
		<div 
			className={`car-node ${isDarken() ? 'darken' : ''} ${isDonated ? 'donated' : ''}`}
			onClick={onClick}
			onMouseMove={() => hoverCarNode?.(rank)}
			onMouseLeave={() => hoverCarNode?.(0)}
		>
			<div className='car-node-picture'>
				<img src={getCarImagePath(name)} alt={name} />
			</div>

			<div className='car-node-content'>
				<div className='car-node-content-item car-node-experience-wrapper' style={{ visibility: isDonated ? 'hidden' : 'visible' }}>
					<img src="/icons/32px/xp.png" alt="experience" />
					<p>{experience || 0}</p>
				</div>

				<div className='car-node-content-item'>
					<div className={`car-node-name ${isDonated ? 'donated' : ''}`}>{name}</div>	
					<div className={`car-node-brand ${isDonated ? 'donated' : ''}`}>{brand}</div>
				</div>

			</div>

			<div className='car-node-button-wrapper'>
				{button && !checked && <CarNodeButton 
					type={button.type} 
					price={button.price} 
					onClick={handleClick}
					isShown={showButton}
				/>}
				{checked && 
					<div className='car-node-checked'>
						<img src="/icons/24px/check.png" alt="checked" />
						<div className='car-node-checked-shadow-wrapper'>
							<div className='car-node-checked-shadow'/>
						</div>
					</div>
				}
			</div>

			{isDonated && 
				<div className='car-node-donate-shadow-wrapper'>
					<div className='car-node-donate-shadow'/>
				</div>
			}

			<Handle type="target" position={Position.Left} style={{ visibility: "hidden", transform: 'translateX(3px)' }} />
			<Handle type="source" position={Position.Right} style={{ visibility: "hidden", transform: 'translateX(-4px)' }} />
		</div>
	)
}